<template>
    <div class="fb-messenger bg-white py-6 px-2">
        <div
            class="btn-fb-messenger w-full outline-none flex items-center justify-center"
            @click="openFb()"
        >
            <img src="@/assets/icon/misc/fb-messenger.svg" class="mr-2 align-middle" alt />
            <span class="text-white text-fb">{{ text }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "ButtonFBMessenger",
    props: {
        text: String
    },
    methods: {
        openFb: function () {
            this.setTracking()
            window.location = 'https://www.facebook.com/JCBCardThailandTH/'
        },
        setTracking: function(){
            var currentPath = this.$route.path;
            if(currentPath.indexOf('contact-us') > 0){
                this.tracking.event('contact_us', 'click_contact_facebook', null, null);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/style/base/base.scss";
.btn-fb-messenger {
    height: 55px;
    background: url("~@/assets/button/btn-fb-messenger.svg");
    background-size: 100% 100%;

    img {
        display: inline-block;
    }
}

    .text-fb {
        font-size: 16px;

        @include mini-mobile {
            font-size: 14px;
        }
    }
</style>
